<template>
    <div class="list-select">
        <p
            v-for="(item,index) in newForm"
            :key="index"
            class="item"
            :class="{active: `${newSelect}` === `${item.id}`}"
            @click="handleClick(item)"
        >
            {{item.name}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "list-select",
        props: {
            form: Array,
            select: [Number,String]
        },
        watch:{
            select(vl){this.newSelect = vl},
            newSelect(vl){this.$emit('update:select', vl)},
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form', vl)}
        },
        data(){
            return {
                newForm: this.form,
                newSelect: this.select
            }
        },
        methods: {
            handleClick(item){
                this.newSelect = item.id
                this.$emit('onTypeSelect', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.list-select {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;

    .item {
        display: flex;
        justify-content: center;
        align-self: flex-start;
        width:120px;
        box-shadow:0px 0px 2px 0px rgba(0, 0, 0, 0.1);
        font-size: 14px;
        color: rgba(153, 153, 153, 1);
        line-height: 30px;
        height: 30px;
        padding: 0px 10px;
        margin-left: 10px;
        margin-bottom: 12px;
        cursor: pointer;

        background:rgba(245,247,250,1);
        border-radius:4px;
        opacity:0.8;


        &:hover, &.active {
            box-shadow:0px 0px 2px 0px #e7622e;
            color: white;

            background:#e7622e;
            border-radius:4px;
            opacity:0.8;
        }
    }
}
</style>
